/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InitiativePlain } from '../types/initiative';
import { apiClient } from '../actions/api';

interface SliceState {
  data: InitiativePlain[],
  errorMessage: string,
  errored: boolean,
  loaded: boolean
  loading: boolean
}
const createState = (): SliceState => ({
  data: [],
  errorMessage: '',
  errored: false,
  loaded: false,
  loading: false,
})

const portfolioTreeSlice = createSlice({
  name: 'portfolioTree',
  initialState: createState(),
  reducers: {
    load: (state) => ({ ...state, loading: true }),
    loaded(state, action: PayloadAction<InitiativePlain[]>) {
      return { ...state, data: action.payload, loaded: true, loading: false };
    },
    handleError(state, action: PayloadAction<string>) {
      return {
        ...state,
        loaded: true,
        loading: false,
        errored: true,
        errorMessage: action.payload
      };
    },
  }
});


const { load, loaded, handleError } = portfolioTreeSlice.actions

export const loadPortfolioTree = () => (dispatch: any, getState: () => any) => {
  const sliceState: SliceState = getState()[portfolioTreeSlice.name];
  if (sliceState.loaded || sliceState.loading) {
    return;
  }
  dispatch(load());

  dispatch(reloadPortfolioTree());
}

export const reloadPortfolioTree = () => (dispatch: any, getState: () => any) => {
  apiClient.getPortfolioTree()
    .then((data) => {
      dispatch(loaded(data))
    })
    .catch((e) => handleError(e));
}

export default portfolioTreeSlice.reducer
